<template>
  <LayoutAdmin>
    <div class="main-content">
      <section
        class="section"
        v-if="profile"
      >
        <div class="section-header">
          <h1>Profil Desa {{ form.nama_desa }}</h1>
        </div>

        <div class="section-body">
          <div class="card col-lg-8">
            <div class="card-body">
              <div class="text-right">
                <button
                  class="btn btn-sm"
                  :class="(showForm) ? 'btn-primary' : 'btn-danger'"
                  @click="showForm = !showForm"
                >
                  <i
                    class="fa mr-2"
                    :class="(showForm) ? 'fa-pencil-alt' : 'fa-times'"
                  />
                  {{ (showForm) ? 'Edit profil desa' : 'Batal' }}
                </button>
              </div>
              <div class="text-center mt-3 mb-5">
                <img
                  alt="image"
                  src="./../../assets/img/icon-jembrana-20.png"
                  style="max-width: 200px"
                >
              </div>
              <form
                action=""
                method=""
                @submit="onSubmit"
              >
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >Nama Desa</label>
                  <div class="col-lg-8">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.nama_desa"
                      :disabled="showForm"
                      required
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >Kecamatan</label>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.nama_kecamatan"
                      disabled
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >Kabupaten</label>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.nama_kabkot"
                      disabled
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >Kode Desa</label>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.kode_desa"
                      disabled
                    >
                  </div>
                </div>

                <h4 class="section-title">
                  Kepala Desa
                </h4>
                <hr>
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >Nama Kepala Desa</label>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.desakel_kepala_nama"
                      :disabled="showForm"
                      required
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >NIP</label>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.desakel_kepala_nip"
                      :disabled="showForm"
                      required
                    >
                  </div>
                </div>

                                
                <h4 class="section-title">
                  Sekretaris Desa
                </h4>
                <hr>
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >Nama Sekretaris Desa</label>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.desakel_sek_nama"
                      :disabled="showForm"
                      required
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label
                    for=""
                    class="col-form-label col-lg-4 text-lg-right text-left"
                  >NIP</label>
                  <div class="col-lg-6">
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.desakel_sek_nip"
                      :disabled="showForm"
                      required
                    >
                  </div>
                </div>

                <div
                  class="row"
                  v-if="!showForm"
                >
                  <div class="col-lg-8 offset-lg-4">
                    <button
                      id="btnSimpan"
                      type="submit"
                      class="btn btn-primary"
                    >
                      <i class="fa fa-check mr-2" />Simpan
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<style scoped>

</style>

<script>
import swal from 'sweetalert'
import LayoutAdmin from './../layouts/Admin.vue'


export default {
  name: 'App',
  data() {
    return {
      form: {
        nama_desa: '',
        nama_kecamatan: '',
        nama_kabkot: '',
        kode_desa: '',
        desakel_kepala_nama: '',
        desakel_kepala_nip: '',
        desakel_sek_nama: '',
        desakel_sek_nip: ''
      },
      showForm: true
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    },
    profile() {
      return this.$store.getters.getUserProfile
    },
    desaUser() {
      return this.$store.getters.getDesaUser
    }
  },
  components: {
    LayoutAdmin
  },
  methods: {
    setForm(data) {
      this.form.nama_desa = data.nama_desa
      this.form.nama_kecamatan = data.nama_kecamatan
      this.form.nama_kabkot = data.nama_kabkot
      this.form.kode_desa = data.kode_desa
      this.form.desakel_kepala_nama = data.desakel_kepala_nama
      this.form.desakel_kepala_nip = data.desakel_kepala_nip
      this.form.desakel_sek_nama = data.desakel_sek_nama
      this.form.desakel_sek_nip = data.desakel_sek_nip
    },
    onSubmit(e) {
      e.preventDefault()

      if (this.form.desakel_kepala_nama.length < 2 || this.form.desakel_kepala_nama.length > 100) {
        swal({
          title: "Kesalahan",
          text: 'Nama kepala desa tidak valid',
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.form.desakel_sek_nama.length < 2 || this.form.desakel_sek_nama.length > 100) {
        swal({
          title: "Kesalahan",
          text: 'Nama sekretaris desa tidak valid',
          icon: "error",
          buttons: "Ok"
        })
        return false
      }

      let button = document.querySelector('#btnSimpan')
      let buttonHtml = button.innerHTML


      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'


      let form = new FormData()
      form.append('nama_desa', this.form.nama_desa)
      form.append('desakel_kepala_nama', this.form.desakel_kepala_nama)
      form.append('desakel_kepala_nip', this.form.desakel_kepala_nip)
      form.append('desakel_sek_nama', this.form.desakel_sek_nama)
      form.append('desakel_sek_nip', this.form.desakel_sek_nip)

      let data = {
        id: this.desaUser.id_desa,
        data: form
      }


      this.$store.dispatch('updateDesa', data).then(res => {
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
        if (res.data.status) {
          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          })
          this.showForm = true
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }

      }).catch(err => {
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: "Gagal",
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;

          default:
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
            break;
        }
      })
    },
    showDesa(id) {
      this.$store.dispatch('showDesa', id).then(res => {
        if (res.data.status) {
          this.setForm(res.data.data)
        }
      })
    }
  },
  created() {
    if (this.profile) {
      this.showDesa(this.profile.id_desa)
    }
  },
  watch: {
    profile(newVal) {
      this.showDesa(newVal.id_desa)
    }
  }
}
</script>

<style>

</style>
